// extracted by mini-css-extract-plugin
export default {"btnpwd":"f48ac8b151"};